import React from "react";
import PreUserTable from "./pre-user-table";
import ExportButtons from "./export-buttons";
import UsersTable from "./users-table";

interface Props {
  accountList: any[];
  isListClients: boolean;
  parentUserId: string;
  tabsContent?: React.ReactNode;
  searchText: string;
  onSearchChange: (value: string) => void;
  onLoad: () => void;
  onReset: () => void;
  pageSize: number;
  onPageSizeChange: (size: number) => void;
  currentPage: number;
  totalRecords: number;
  onPageChange: (page: number) => void;
}

const UsersList: React.FC<Props> = ({
  accountList,
  isListClients,
  parentUserId,
  tabsContent,
  searchText,
  onSearchChange,
  onLoad,
  onReset,
  pageSize,
  onPageSizeChange,
  currentPage,
  totalRecords,
  onPageChange,
}) => {
  const totalPages = Math.max(1, Math.ceil(totalRecords / pageSize));
  const isFirstPage = currentPage <= 1;
  const isLastPage = currentPage >= totalPages;

  return (
    <>
      <PreUserTable
        accountList={accountList}
        isListClients={isListClients}
        searchText={searchText}
        onSearchChange={onSearchChange}
        onLoad={onLoad}
        onReset={onReset}
        pageSize={pageSize}
        onPageSizeChange={onPageSizeChange}
      />

      {tabsContent}

      <div className="table-responsive mb-0">
        {isListClients && (
          <ExportButtons accountList={accountList} isListClients />
        )}
        <UsersTable
          isListClients={isListClients}
          accountList={accountList}
          parentUserId={parentUserId}
        />
      </div>

      <div className="row pt-3">
        <div className="col">
          <div className="dataTables_paginate paging_simple_numbers float-right">
            <ul className="pagination pagination-rounded mb-0">
              <ul
                role="menubar"
                aria-disabled="false"
                aria-label="Pagination"
                className="pagination dataTables_paginate paging_simple_numbers my-0 b-pagination justify-content-end"
              >
                <li
                  role="presentation"
                  aria-hidden={isFirstPage}
                  className={`page-item ${isFirstPage ? "disabled" : ""}`}
                >
                  <button
                    role="menuitem"
                    type="button"
                    aria-label="Go to first page"
                    aria-disabled={isFirstPage}
                    disabled={isFirstPage}
                    tabIndex={isFirstPage ? -1 : 0}
                    className="page-link"
                    onClick={() => onPageChange(1)}
                  >
                    &laquo;
                  </button>
                </li>
                <li
                  role="presentation"
                  aria-hidden={isFirstPage}
                  className={`page-item ${isFirstPage ? "disabled" : ""}`}
                >
                  <button
                    role="menuitem"
                    type="button"
                    aria-label="Go to previous page"
                    aria-disabled={isFirstPage}
                    disabled={isFirstPage}
                    tabIndex={isFirstPage ? -1 : 0}
                    className="page-link"
                    onClick={() => onPageChange(currentPage - 1)}
                  >
                    &lsaquo;
                  </button>
                </li>
                {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
                  <li
                    key={page}
                    role="presentation"
                    className={`page-item ${currentPage === page ? "active" : ""}`}
                  >
                    <button
                      role="menuitemradio"
                      type="button"
                      aria-label={`Go to page ${page}`}
                      aria-checked={currentPage === page}
                      aria-posinset={page}
                      aria-setsize={totalPages}
                      tabIndex={0}
                      className="page-link"
                      onClick={() => onPageChange(page)}
                    >
                      {page}
                    </button>
                  </li>
                ))}
                <li
                  role="presentation"
                  aria-hidden={isLastPage}
                  className={`page-item ${isLastPage ? "disabled" : ""}`}
                >
                  <button
                    role="menuitem"
                    type="button"
                    aria-label="Go to next page"
                    aria-disabled={isLastPage}
                    disabled={isLastPage}
                    tabIndex={isLastPage ? -1 : 0}
                    className="page-link"
                    onClick={() => onPageChange(currentPage + 1)}
                  >
                    &rsaquo;
                  </button>
                </li>
                <li
                  role="presentation"
                  aria-hidden={isLastPage}
                  className={`page-item ${isLastPage ? "disabled" : ""}`}
                >
                  <button
                    role="menuitem"
                    type="button"
                    aria-label="Go to last page"
                    aria-disabled={isLastPage}
                    disabled={isLastPage}
                    tabIndex={isLastPage ? -1 : 0}
                    className="page-link"
                    onClick={() => onPageChange(totalPages)}
                  >
                    &raquo;
                  </button>
                </li>
              </ul>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default UsersList;
